import {
  TcNotesReportRef,
  TcNotesStatus
} from 'src/state/report/interfaces';

export const hasTcNotesGenerated = (
  report?: TcNotesReportRef | null
): boolean => Boolean(report?.tcNotes?.url?.trim());

export const getTcNotesStatus = (
  report?: TcNotesReportRef | null
): TcNotesStatus =>
  hasTcNotesGenerated(report)
    ? TcNotesStatus.GENERATED
    : TcNotesStatus.NOT_GENERATED;

export const isTcNotesGenerated = (status?: TcNotesStatus): boolean =>
  status === TcNotesStatus.GENERATED;
